'use client';

import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Loader360 from '@/components/Loader360';

const LoadingContext = createContext<{
  setLoading: (v: boolean) => void;
}>({ setLoading: () => {} });

export function useLoading() {
  return useContext(LoadingContext);
}

function NavigationLoader() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [prevPath, setPrevPath] = useState<string | null>(null);

  useEffect(() => {
    const currentPath = pathname + searchParams.toString();
    if (prevPath !== null && prevPath !== currentPath) {
      setLoading(true);
      const timer = setTimeout(() => setLoading(false), 600);
      return () => clearTimeout(timer);
    }
    setPrevPath(currentPath);
  }, [pathname, searchParams]);

  if (!loading) return null;
  return <Loader360 fullScreen />;
}

export default function PageTransitionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [manualLoading, setManualLoading] = useState(false);

  const setLoading = useCallback((v: boolean) => setManualLoading(v), []);

  return (
    <LoadingContext.Provider value={{ setLoading }}>
      {manualLoading && <Loader360 fullScreen />}
      <React.Suspense fallback={<Loader360 fullScreen />}>
        <NavigationLoader />
      </React.Suspense>
      {children}
    </LoadingContext.Provider>
  );
}
